import * as QUOTE_API from '@/api/quote'

export default {
  state: {
    current: null,
    list: {},
    items: {},
    defaultMarginSettings: [],
    marginSettings: {},
    priceQuotations: [],
    quoteGroupList: {},
    feeTypes: [],
    remindState: {}
  },
  getters: {
    currentQuote: (state) => {
      return state.current ? state.list[state.current] : null
    },
    quoteLoaded: (state) => {
      return state.loaded
    },
    quotesList: (state) => {
      return state.list
    },
    getQuoteById: state => id => {
      if (state.list[id]) {
        return state.list[id]
      }
      return false
    },
    defaultMarginSettings: (state) => {
      return state.defaultMarginSettings
    },
    marginSettings: state => {
      return state.marginSettings
    },
    getQuoteItems: (state) => (quoteId) => {
      return _.get(state.items, quoteId)
    },
    quoteGroupList: (state) => {
      return state.quoteGroupList
    },
    feeTypes: (state) => state.feeTypes
  },
  mutations: {
    setQuote(state, data) {
      if (state.list[data.id]) {
        state.list[data.id] = Object.assign({}, state.list[data.id], data)
      } else {
        state.list[data.id] = data
      }
    },
    setQuotes(state, list) {
      state.list = list
    },
    deleteQuote(state, id) {
      if (state.list[id]) {
        delete state.list[id]
      }
    },
    setCurrent(state, id) {
      state.current = id
    },
    setDefaultMarginSettings(state, value) {
      state.defaultMarginSettings = value
    },
    setMarginSettings(state, value) {
      state.marginSettings = value
    },
    setPriceQuotations(state, data) {
      state.priceQuotations = data
    },
    setPriceQuotation(state, data) {
      let foundIndex = _.findIndex(state.priceQuotations, { id: data.id })
      if (foundIndex >= 0) {
        state.priceQuotations[foundIndex] = data
      } else {
        state.priceQuotations.push(data)
      }
    },
    setQuoteItems(state, { quoteId, items }) {
      state.items = Object.assign({}, state.items, { [quoteId]: items })
    },
    removeQuoteItem(state, { quoteId, itemId }) {
      let index = state.items[quoteId].findIndex((i) => i.id === itemId)
      state.items[quoteId].splice(index, 1)
    },
    changeOrAddQuoteItem: (state, quoteId, item) => {
      state.items = Object.assign({}, state.items, { [quoteId]: item })
    },
    setQuoteGroupList(state, list) {
      state.quoteGroupList = list
    },
    setFeeTypeList(state, list) {
      state.feeTypes = list
    }
  },
  actions: {
    loadQuotes({ commit }, query) {
      return QUOTE_API.getQuotes(query).then(resp => {
        commit('setQuotes', resp.data)
        return resp
      })
    },
    loadQuote({ commit }, id) {
      return QUOTE_API.getQuote(id).then(resp => {
        commit('setQuote', resp.data)
        commit('setCurrent', id)
        return resp
      })
    },
    addQuote({ commit }, data) {
      commit('setQuote', data)
      commit('setCurrent', data.id)
    },
    createQuote({ commit }, data) {
      return QUOTE_API.createQuote(data).then(resp => {
        commit('setQuote', resp.data)
        commit('setCurrent', resp.data.id)
        return resp
      })
    },
    deleteQuote({ commit }, id) {
      return QUOTE_API.deleteQuote(id).then(resp => {
        commit('deleteQuote', id)
        commit('setCurrent', null)
      })
    },
    searchQuote({ commit }, query) {
      return QUOTE_API.searchQuote(query).then(resp => {
        commit('setQuotes', resp.data)
        return resp
      })
    },
    updateQuote({ commit }, { id, data }) {
      return QUOTE_API.updateQuote(id, data).then(resp => {
        if (!data['id']) data['id'] = id
        commit('setQuote', data)
        commit('setCurrent', id)
        return resp
      })
    },
    loadDefaultMarginSettings({ commit }) {
      return QUOTE_API.getDefaultMarginSettings().then(resp => {
        commit('setDefaultMarginSettings', resp.data)
      })
    },
    saveMarginSettings({ commit }, { quoteId, data }) {
      return QUOTE_API.saveMarginSettings(quoteId, data)
    },
    // Quote items
    getQuoteItems({ commit }, { quoteId, data }) {
      return QUOTE_API.getQuoteItems(quoteId, data).then(res => {
        commit('setQuoteItems', { quoteId: quoteId, items: res.data })
        return res
      })
    },
    createQuoteItem({ commit }, { quoteId, data }) {
      return QUOTE_API.createQuoteItem(quoteId, data).then(res => {
        commit('changeOrAddQuoteItem', { quoteId: quoteId, item: res.data })
        return res
      })
    },
    updateQuoteItem({ commit }, { quoteId, data }) {
      return QUOTE_API.updateQuoteItem(quoteId, data.id, data).then(res => {
        commit('changeOrAddQuoteItem', { quoteId: quoteId, item: res.data })
        return res
      })
    },
    deleteQuoteItem({ commit }, { quoteId, data }) {
      return QUOTE_API.deleteQuoteItem(quoteId, data.id).then(res => {
        commit('removeQuoteItem', { quoteId: quoteId, itemId: data.id })
        return res
      })
    },
    sendQuoteItemsToHubSpot({ commit }, quoteId) {
      return QUOTE_API.sendQuoteItemsToHubSpot(quoteId)
    },
    // clone
    saveCloneQuote({ commit }, { quoteId, data }) {
      return QUOTE_API.saveCloneQuote(quoteId, data)
    },
    getCloneQuoteList({ commit }, { quoteId, quoteType }) {
      return QUOTE_API.getCloneQuoteList(quoteId, quoteType)
    },
    getQuoteRelated({ commit }, { quoteId, relatedType }) {
      return QUOTE_API.getQuoteRelated(quoteId, relatedType)
    },
    // margin-setting
    getCosts({ commit }, quoteId) {
      return QUOTE_API.getCosts(quoteId)
    },
    saveCosts({ commit }, { quoteId, data }) {
      return QUOTE_API.saveCosts(quoteId, data)
    },
    getMarginSummary({ commit }, quoteId) {
      return QUOTE_API.getMarginSummary(quoteId)
    },
    saveMarginBreakdowns({ commit }, { quoteId, data }) {
      return QUOTE_API.saveMarginBreakdowns(quoteId, data)
    },
    getMarginBreakdowns({ commit }, quoteId) {
      return QUOTE_API.getMarginBreakdowns(quoteId)
    },
    getMarginSnapshots({ commit }, quoteId) {
      return QUOTE_API.getMarginSnapshots(quoteId)
    },
    getMarginSnapshotsById({ commit }, { quoteId, snapshotId }) {
      return QUOTE_API.getMarginSnapshotsById(quoteId, snapshotId)
    },
    createCosts({ commit }, { quoteId, data }) {
      return QUOTE_API.createCosts(quoteId, data)
    },
    getCostSummary({ commit }, quoteId) {
      return QUOTE_API.getCostSummary(quoteId)
    },
    getCostQuantity({ commit }, cost_estimator_id) {
      return QUOTE_API.getCostQuantity(cost_estimator_id)
    },
    getMarginBreakDetail({ commit }, { quoteId, reportName }) {
      return QUOTE_API.getMarginBreakDetail(quoteId, reportName)
    },
    getPDFList({ commit }, quoteId) {
      return QUOTE_API.getPDFList(quoteId)
    },
    getSinglePDF({ commit }, { quoteId, documentId }) {
      return QUOTE_API.getSinglePDF(quoteId, documentId)
    },
    createSinglePDF({ commit }, { quoteId, data }) {
      return QUOTE_API.createSinglePDF(quoteId, data)
    },
    updateSinglePDF({ commit }, { quoteId, documentId, data }) {
      return QUOTE_API.updateSinglePDF(quoteId, documentId, data)
    },
    getQuoteBom({ commit }, quoteId) {
      return QUOTE_API.getQuoteBom(quoteId)
    },
    // Quote group
    createQuoteGroup({ commit }, { type, data }) {
      return QUOTE_API.createQuoteGroup(type, data)
    },
    updateQuoteGroup({ commit }, { id, data }) {
      return QUOTE_API.updateQuoteGroup(id, data)
    },
    deleteQuoteGroup({ commit }, id) {
      return QUOTE_API.deleteQuoteGroup(id)
    },
    getQuoteGroup({ commit }, id) {
      return QUOTE_API.getQuoteGroup(id)
    },
    createQuoteFromQuoteGroup({ commit }, { id, data }) {
      return QUOTE_API.createQuoteFromGroupQuote(id, data)
    },
    getQuoteGroupList({ commit }, params) {
      return QUOTE_API.getQuoteGroupList(params).then((resp) => {
        commit('setQuoteGroupList', resp.data)
        return resp
      })
    },
    getQuotesFromQuoteGroup({ commit }, id) {
      return QUOTE_API.getQuotesFromQuoteGroup(id)
    },
    getFeeTypes({ commit }) {
      return QUOTE_API.getFeeTypes().then((resp) => {
        commit('setFeeTypeList', resp.data)
        return resp
      })
    },
    getDeals({ commit }, params) {
      return QUOTE_API.getDeals(params)
    },
    associateQuoteRelated({ commit }, { quoteId, type, typeId }) {
      return QUOTE_API.associateQuoteRelated(quoteId, type, typeId)
    },
    syncQuoteToHubSpot({ commit }, { quoteId, data }) {
      return QUOTE_API.sendQuoteToHubSpot(quoteId, data)
    },
    getQuoteTemplates({ commit }, data) {
      return QUOTE_API.getQuoteTemplates(data)
    },
    getQuoteActivitiesTimeline({ commit }, id) {
      return QUOTE_API.getQuoteActivitiesTimeline(id)
    },
    downloadQuotation({ commit }, { quoteId, documentId }) {
      return QUOTE_API.downloadQuotation(quoteId, documentId)
    }

  }
}
